// extracted by mini-css-extract-plugin
export default {"imgBox":"Profile_imgBox__-u0A7","img":"Profile_img__Lv9Xl","list":"Profile_list__WR681","line":"Profile_line__0QGdp","phone":"Profile_phone__mBUV4"};